import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const MAX_POLLS = 8;
const POLL_INTERVAL_MS = 2000;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refreshUser } = useAuth();
  const [state, setState] = useState("checking"); // checking | paid | timeout | error
  const polls = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { setState("error"); return; }
    let timer;
    const poll = async () => {
      if (polls.current >= MAX_POLLS) { setState("timeout"); return; }
      polls.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          await refreshUser();
          toast.success("Your membership is confirmed");
          return;
        }
        if (data.status === "expired" || data.payment_status === "failed") {
          setState("error");
          return;
        }
      } catch (e) { /* keep polling */ }
      timer = setTimeout(poll, POLL_INTERVAL_MS);
    };
    poll();
    return () => clearTimeout(timer);
  }, [params, refreshUser]);

  return (
    <div className="max-w-xl mx-auto px-6 py-32 text-center" data-testid="payment-success-page">
      <span className="hanko text-primary text-4xl">祝</span>
      {state === "checking" && (
        <>
          <h1 className="font-serif text-4xl mt-6" data-testid="payment-checking">Confirming your membership…</h1>
          <p className="mt-4 text-muted-foreground">A moment while the ink dries.</p>
        </>
      )}
      {state === "paid" && (
        <>
          <h1 className="font-serif text-5xl mt-6" data-testid="payment-paid">Welcome to your new rank.</h1>
          <p className="mt-4 text-muted-foreground">Finer robes now await you in the Kimono Room.</p>
          <Link to="/kimono" data-testid="go-to-kimono"
            className="mt-8 inline-block bg-primary text-primary-foreground px-8 py-3 text-sm hover:-translate-y-0.5 transition-transform">
            Choose your robe
          </Link>
        </>
      )}
      {(state === "timeout" || state === "error") && (
        <>
          <h1 className="font-serif text-4xl mt-6">Still processing…</h1>
          <p className="mt-4 text-muted-foreground">
            If you completed payment, your tier will update shortly. Otherwise you can try again.
          </p>
          <Link to="/kimono" className="mt-8 inline-block border border-border px-8 py-3 text-sm hover:border-primary transition-colors">
            Back to the Kimono Room
          </Link>
        </>
      )}
    </div>
  );
}
